import { useState, useEffect } from "react";
import { activitiesAPI } from "../services/api";

export const useActivities = (filters) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    const fetchActivities = async () => {
      if (isInitialLoad) {
        setLoading(true);
      } else {
        setIsFetching(true);
      }
      try {
        const response = await activitiesAPI.getAll(filters);
        const fetchedActivities = response.data;

        setActivities(fetchedActivities);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        if (isInitialLoad) {
          setLoading(false);
          setIsInitialLoad(false);
        }
        setIsFetching(false);
      }
    };

    const debounceId = setTimeout(fetchActivities, isInitialLoad ? 0 : 300);
    return () => clearTimeout(debounceId);
  }, [filters, isInitialLoad]);

  return { activities, loading, isFetching, error };
};
